import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { arrayOf, array, bool, func, node, oneOfType, shape, string } from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/omit';
import { propTypes, LISTING_STATE_CLOSED, LINE_ITEM_NIGHT, LINE_ITEM_DAY } from '../../util/types';
import { formatMoney } from '../../util/currency';
import { ensureListing } from '../../util/data';
import { parse, stringify } from '../../util/urlHelpers';
import config from '../../config';
import { ModalInMobile, Button } from '../../components';
import { BookingDatesForm } from '../../forms';

import css from './BookingPanel.css';

// This defines when ModalInMobile shows content as Modal
const MODAL_BREAKPOINT = 1023;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};



const openBookModal = (isOwnListing, isClosed, history, location) => {
  if (isOwnListing || isClosed) {
    if (window !== undefined) window.scrollTo(0, 0);
  } else {
    const { pathname, search, state } = location;
    const searchString = `?${stringify({ ...parse(search), book: true })}`;
    history.push(`${pathname}${searchString}`, state);
  }
};

const closeBookModal = (history, location) => {
  const { pathname, search, state } = location;
  const searchParams = omit(parse(search), 'book');
  const searchString = `?${stringify(searchParams)}`;
  history.push(`${pathname}${searchString}`, state);
};

const BookingPanel = props => {
  const {
    rootClassName,
    className,
    titleClassName,
    listing,
    isOwnListing,
    unitType,
    onSubmit,
    title,
    // subTitle,
    authorDisplayName,
    onManageDisableScrolling,
    timeSlots,
    fetchTimeSlotsError,
    history,
    location,
    intl,
    onFetchTransactionLineItems,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    ProjectRoomtype,
    projectRoomtypeRaw,
    bedamount,
    isAuthenticated,
    currentUser,
    isProvider,
    isCustomer,
    isEnquired,
    onEnquire,
  } = props;
 
  //Checking if custom Currency is set to Euro
const currentListing = ensureListing(listing);
const currencyCheck = (customCurrency, shareTribePrice) => {
  if(customCurrency!==undefined){
    if ((customCurrency).includes('Euro')){
      return (shareTribePrice.substr(1)+ "€");
    }else{
      return shareTribePrice;
    }
  }else{
    return shareTribePrice;
  }
}

  const price = listing.attributes.price;
  const hasListingState = !!listing.attributes.state;
  const isClosed = hasListingState && listing.attributes.state === LISTING_STATE_CLOSED;
  const showBookingDatesForm = hasListingState && !isClosed;
  // const showClosedListingHelpText = listing.id && isClosed;
  const { formattedPrice, priceTitle } = priceData(price, intl);
  const isBook = !!parse(location.search).book;


  // const subTitleText = !!subTitle
  //   ? subTitle
  //   : showClosedListingHelpText
  //   ? intl.formatMessage({ id: 'BookingPanel.subTitleClosedListing' })
  //   : null;

  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;

  const unitTranslationKey = isNightly
    ? 'BookingPanel.perNight'
    : isDaily
      ? 'BookingPanel.perDay'
      : 'BookingPanel.perUnit';

  const classes = classNames(rootClassName || css.root, className);
  const titleClasses = classNames(titleClassName || css.bookingTitle);

  const pricePer =
    projectRoomtypeRaw === 'shared_bedroom' ? (
      <FormattedMessage id="ListingCard.pricePerBed" />
    ) : projectRoomtypeRaw === 'singlebedroom' ? (
      <FormattedMessage id="ListingCard.pricePerRoom" />
    ) : projectRoomtypeRaw === 'twobedroom' ? (
      <FormattedMessage id="ListingCard.pricePerRoom" />
    ) : projectRoomtypeRaw === 'doublebedroom' ? (
      <FormattedMessage id="ListingCard.pricePerRoom" />
    ) : (
      ''
    );
  const ProjectRoomtypeIcon =
    projectRoomtypeRaw === 'singlebedroom' ? (
      <img
        src={require('../../assets/icons/roomtypes/onebedroom.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : projectRoomtypeRaw === 'twobedroom' ? (
      <img
        src={require('../../assets/icons/roomtypes/twobedroom.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : projectRoomtypeRaw === 'doublebedroom' ? (
      <img
        src={require('../../assets/icons/roomtypes/doublebedroom.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : projectRoomtypeRaw === 'shared_bedroom' ? (
      <img
        src={require('../../assets/icons/roomtypes/shared_bedroom.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : projectRoomtypeRaw === 'entire_accomodation' ? (
      <img
        src={require('../../assets/icons/roomtypes/entire_accomodation.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : projectRoomtypeRaw === 'camping' ? (
      <img
        src={require('../../assets/icons/roomtypes/camping.png')}
        width="auto"
        height="60px"
        style={{ paddingRight: '20px', paddingLeft: '0px' }}
        alt=""
      ></img>
    ) : null;

  return (
    <div className={classes}>
      <ModalInMobile
        containerClassName={css.modalContainer}
        id="BookingDatesFormInModal"
        isModalOpenOnMobile={isBook}
        onClose={() => closeBookModal(history, location)}
        showAsModalMaxWidth={MODAL_BREAKPOINT}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div className={css.modalHeading}>
          <h1 className={css.title}>{title}</h1>
          <div className={css.author}>
            <FormattedMessage id="BookingPanel.hostedBy" values={{ name: authorDisplayName }} />
          </div>
        </div>

        <div className={css.bookingHeading}>
          {ProjectRoomtypeIcon}
          <div>
            <h3 style={{ fontWeight: '100', color: '#353535' }}>{ProjectRoomtype}</h3>
            {/* {subTitleText ? <div className={css.bookingHelp}>{subTitleText}</div> : null} */}
            <h3 className={titleClasses}>
              {/* Wähle deine Reisedaten aus, damit wir dir den Preis anzeigen können */}
              {currencyCheck(currentListing.attributes.publicData.customCurrency, formattedPrice)}{' '}
              <span style={{ fontWeight: '100', color: '#353535' }}>
                <FormattedMessage id="BookingPanel.night" /> {pricePer}
              </span>
            </h3>

          </div>
        </div>
        {showBookingDatesForm ? (
          <BookingDatesForm
            className={css.bookingForm}
            formId="BookingPanel"
            submitButtonWrapperClassName={css.bookingDatesSubmitButtonWrapper}
            unitType={unitType}
            onEnquire={onEnquire}
            onSubmit={onSubmit}
            price={price}
            listing={listing}
            listingId={listing.id}
            isOwnListing={isOwnListing}
            timeSlots={timeSlots}
            fetchTimeSlotsError={fetchTimeSlotsError}
            onFetchTransactionLineItems={onFetchTransactionLineItems}
            lineItems={lineItems}
            fetchLineItemsInProgress={fetchLineItemsInProgress}
            fetchLineItemsError={fetchLineItemsError}
            bedamount={bedamount}
            projectRoomtypeRaw={projectRoomtypeRaw}
            isAuthenticated={isAuthenticated}
            currentUser={currentUser}
            listingPathName={props.listingPathName}
            isProvider={isProvider}
            isCustomer={isCustomer}
            isEnquired={isEnquired}
          />
        ) : null}
      </ModalInMobile>
      <div className={css.openBookingForm}>
        <div className={css.priceContainer}>
          <div className={css.priceValue} title={priceTitle}>
            {currencyCheck(currentListing.attributes.publicData.customCurrency, formattedPrice)}
          </div>
          <div className={css.perUnit}>
            <FormattedMessage id={unitTranslationKey} />
          </div>
        </div>

        {showBookingDatesForm ? (
          <div>
            <Button
              rootClassName={css.bookButton}
              onClick={() => openBookModal(isOwnListing, isClosed, history, location)}
            >
              <FormattedMessage id="BookingPanel.ctaButtonMessage" />
            </Button>
          </div>
        ) : isClosed ? (
          <div className={css.closedListingButton}>
            <FormattedMessage id="BookingPanel.closedListingButtonText" />
          </div>
        ) : null}
      </div>
    </div>
  );
};

BookingPanel.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  isOwnListing: false,
  subTitle: null,
  unitType: config.bookingUnitType,
  timeSlots: null,
  fetchTimeSlotsError: null,
  lineItems: null,
  fetchLineItemsError: null,
};

BookingPanel.propTypes = {
  rootClassName: string,
  className: string,
  titleClassName: string,
  listing: oneOfType([propTypes.listing, propTypes.ownListing]),
  isOwnListing: bool,
  unitType: propTypes.bookingUnitType,
  onSubmit: func.isRequired,
  title: oneOfType([node, string]).isRequired,
  subTitle: oneOfType([node, string]),
  authorDisplayName: oneOfType([node, string]).isRequired,
  onManageDisableScrolling: func.isRequired,
  timeSlots: arrayOf(propTypes.timeSlot),
  fetchTimeSlotsError: propTypes.error,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default compose(withRouter, injectIntl)(BookingPanel);
